module.exports = __webpack_public_path__ + "static/media/kitchen_bundle_hero.dbb88c52.png";